import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "svg-icon svg-icon-3" }
const _hoisted_2 = { class: "svg-icon svg-icon-3" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "las la-trash" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createBlock(_component_el_table, {
    "empty-text": "Chưa có bản kế hoạch sửa chữa nào trong hệ thống",
    style: {"width":"100%"},
    border: true,
    data: _ctx.items
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_table_column, {
        label: "STT",
        width: "55"
      }, {
        default: _withCtx((scope) => [
          _createTextVNode(_toDisplayString(scope.row.stt), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, { label: "Số biên bản" }, {
        default: _withCtx((scope) => [
          _createTextVNode(_toDisplayString(scope.row.so_bien_ban), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, { label: "Ngày vào xưởng" }, {
        default: _withCtx((scope) => [
          _createTextVNode(_toDisplayString(_ctx.moment(scope.row.ngay_vao_xuong).format("DD/MM/YYYY")), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, { label: "Tên kế hoạch" }, {
        default: _withCtx((scope) => [
          _createTextVNode(_toDisplayString(scope.row.ke_hoach_sua_chua &&
          scope.row.ke_hoach_sua_chua.ten_ke_hoach), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, { label: "Toa xe" }, {
        default: _withCtx((scope) => [
          _createTextVNode(_toDisplayString(scope.row.ke_hoach_sua_chua &&
          scope.row.ke_hoach_sua_chua.san_pham &&
          scope.row.ke_hoach_sua_chua.san_pham.ten_san_pham), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, { label: "Số hiệu" }, {
        default: _withCtx((scope) => [
          _createTextVNode(_toDisplayString(scope.row.ke_hoach_sua_chua &&
          scope.row.ke_hoach_sua_chua.san_pham &&
          scope.row.ke_hoach_sua_chua.san_pham.so_hieu), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "",
        width: "150"
      }, {
        default: _withCtx((scope) => [
          _createVNode(_component_router_link, {
            to: '/quan-ly/bien-ban-giai-the/chi-tiet/' + scope.row.id,
            class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_1, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen044.svg" })
              ])
            ]),
            _: 2
          }, 1032, ["to"]),
          _createVNode(_component_router_link, {
            to: '/quan-ly/bien-ban-giai-the/cap-nhat/' + scope.row.id,
            class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_2, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/art/art005.svg" })
              ])
            ]),
            _: 2
          }, 1032, ["to"]),
          _createElementVNode("a", {
            href: "javascript:;",
            class: "btn btn-icon btn-bg-light btn-active-color-danger btn-sm me-1",
            onClick: ($event: any) => (_ctx.remove(scope.row.id))
          }, _hoisted_5, 8, _hoisted_3)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["data"]))
}